import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Projects.scss";
import { Link } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IOrder from "../../../models/IOrder";
import IOwTableCols from "../../../models/IOwTableCols";
import IProject from "../../../models/IProject";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import UserService from "../../../services/UserService";
import VendorService from "../../../services/VendorService";
import SocketService from "../../../services/SocketService";
import socketIOClient from "socket.io-client";
import * as _ from "lodash-es";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import ProjectSidebar from "../ProjectSidebar/ProjectSidebar";
import { Socket } from "socket.io-client";
import AccessTypesEnum from "../../../models/AccessTypesEnum";
import EndpointsEnum from "../../../models/EndpointsEnum";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    supplierModel: ISupplierModel;
};

type State = {
    crumbs: IBreadcrumbs[];
    projects: IProject[];
    columns: IOwTableCols[];
    detailViewColumns: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
    offset: number;
    limit: number;
    totalProjects: number;
};

class Projects extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            projects: [],
            columns: [
                {
                    hasChevron: true,
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderActionsCol,
                    renderFnEmitsRow: true,
                },
                {
                    title: "vendor",
                    valueProp: "Vendor",
                    valueSubProp: "name",
                    isVendorOverride: true,
                },
                {
                    title: "name",
                    valueProp: "name",
                },
                {
                    title: "address",
                    valueProp: "",
                    renderFn: this.renderAddressCol,
                    renderFnEmitsRow: true,
                },
            ],
            detailViewColumns: [
                {
                    title: "vendor",
                    valueProp: "Vendor",
                    valueSubProp: "name",
                    isVendorOverride: true,
                    renderFn: this.renderVendorName,
                    renderFnEmitsRow: true,
                    className: "w-15r",
                },
                {
                    title: "order",
                    valueProp: "name",
                    renderFn: this.renderOrderCol,
                    renderFnEmitsRow: true,
                    className: "w-10r",
                },
                {
                    title: "description",
                    valueProp: "description",
                },
            ],
            isDataFetching: false,
            isInitialData: true,
            crumbs: [
                {
                    title: "dashboard",
                    url: "/dashboard",
                },
                {
                    title: "projects",
                    url: "/projects",
                },
            ],
            offset: 0,
            limit: 25,
            totalProjects: 0,
        };

        document.title = `Orderwerks >> Projects`;
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.ProjectsOnGetProjects, this.onGetProjects);

        this.getProjects();
    }

    componentWillUnmount() {
        this.props.socket.off(EndpointsEnum.ProjectsOnGetProjects, this.onGetProjects);
    }

    editProject = (row: IProject) => {
        this.openProjectSidebar(row);
    };

    renderActionsCol = (row: IProject) => {
        return (
            <div className={this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY ? "d-none" : ""}>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {}}
                    onEditClickFn={() => {
                        this.editProject(row);
                    }}
                    hideTrash={true}
                />
            </div>
        );
    };

    renderAddressCol = (row: IProject) => {
        return (
            <div className={"d-flex"}>
                {this.props.supplierModel.has_google_maps ? (
                    <OwGoogleStaticMap address={row.Address!} size={"150x150"} className={"me-2"} />
                ) : null}
                <AddressDisplay address={row.Address} />
            </div>
        );
    };

    renderVendorName = (row: IOrder) => {
        return <Link to={`/vendors/${row.Vendor?.guid}`}>{row.Vendor?.name}</Link>;
    };

    renderOrderCol = (row: IOrder) => {
        return <Link to={`/orders/${row.guid}/entry`}>{row.name}</Link>;
    };

    getProjects = () => {
        const payload: any = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            limit: this.state.limit,
            offset: this.state.offset,
        };

        this.props.socket.emit(EndpointsEnum.ProjectsGetProjects, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetProjects = (data: any) => {
        const { projects, totalProjects } = data;

        this.setState({
            projects,
            totalProjects,
            isDataFetching: false,
            isInitialData: false,
        });
    };

    openProjectSidebar = (project?: IProject) => {
        const component = (
            <ProjectSidebar
                cancelFn={this.cancelSidebar}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                project={project}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    cancelSidebar = (refreshData?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (refreshData) {
            this.getProjects();
        }
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getProjects();
            }
        );
    };

    render() {
        return (
            <div className="Projects">
                <div className="row mt-2">
                    <div className={"col-12 d-flex align-items-center"}>
                        <OwTitle title={"projects"} leftIconName={"fad fa-project-diagram"} />
                        <div
                            className={
                                this.props.userModel.supplierUserToken?.Access_Type?.id === AccessTypesEnum.READ_ONLY ? "d-none" : ""
                            }>
                            <OwButton
                                className={"ms-2 btn-warning"}
                                title={"create"}
                                leftIconClass={"fas fa-plus"}
                                fn={() => {
                                    this.openProjectSidebar();
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12">
                        <OwTable
                            columns={this.state.columns}
                            detailViewColumns={this.state.detailViewColumns}
                            detailViewDataSet={this.state.projects}
                            detailViewDataSetProp={"Orders"}
                            dataSet={this.state.projects}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={this.state.isDataFetching}
                            initialData={this.state.isInitialData}
                            tableConfig={{ tableStriped: true, hasDetailView: true }}
                        />
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <PaginationBar
                            offset={this.state.offset}
                            limit={this.state.limit}
                            totalRecords={this.state.totalProjects}
                            onPaginationChanged={this.paginationChanged}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Projects;
